import { observer } from "mobx-react-lite";

/**
 * This component previously loaded vault balances from Hasura.
 * Now vault balances are loaded from /api/v1/user/portfolio via polling
 * in BalanceStore.fetchAllPortfolios()
 */
export const BalanceStoreLoader = observer(() => {
  return null;
});
